export default __webpack_public_path__ + "static/media/backIcon.9d4e62dc.svg";